import { KText } from '@/ui-library/components/text';
import { XIcon } from '@heroicons/react/outline';
import { Flex, Icon } from '@chakra-ui/react';
import { ToastIcon } from '@/hooks/useShowToast';
import { STATUS_COLORS } from '../../constants';
import { colors } from '@/theme/foundations/colors';

export const KToast = ({ props, status, onClose }) => {
  const { bg, text } = STATUS_COLORS[status];
  return (
    <Flex
      bgColor={colors[bg]}
      justifyContent="space-between"
      borderRadius="6px"
      p="10px"
      alignItems="center"
      gap="24px"
      boxShadow="drop-shadows-bottom"
    >
      <Flex gap="6px" alignItems="center" justifyContent="start">
        <ToastIcon status={status} />
        <Flex flexDir="column">
          <KText
            color={colors[text]}
            size="sm-semi-bold"
            data-test-id="toast-title"
          >
            {props?.title}
          </KText>
          <KText
            color={colors[text]}
            size="xs-medium"
            data-test-id="toast-description"
          >
            {props?.description}
          </KText>
        </Flex>
      </Flex>
      <Icon
        as={XIcon}
        color={colors[text]}
        width="16px"
        cursor={'pointer'}
        height="16px"
        onClick={onClose}
        data-test-id="toast-close-icon"
      ></Icon>
    </Flex>
  );
};
